import HttpService from '../base.service/HttpService'

export default class AuthService extends HttpService {
  login (param) {
    const api = process.env.VUE_APP_API + '/auth/login'
    return this.post(param, api)
  }

  logout (param) {
    const api = process.env.VUE_APP_API + '/auth/logout'
    return this.post(param, api)
  }
}
